import axios from "axios";

axios.defaults.withCredentials = true;

export default {

    async getBySearch(search)
    {
        return (await axios.get(process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_ANNUAIRE + search)).data;
    }

}